const MOCK_API = 'https://mock.xiaojukeji.com/mock/8993'

export const getBaseURL = (
  baseUrl?: string,
  reqUrl?: string
) => {
  const mockable =
    process.env.NODE_ENV === 'development' &&
    window.location.search.includes('mock-api=1')

  // 不走 mock 的接口
  const noneMockUrl = ['/login']

  if (
    mockable &&
    !noneMockUrl.some((url) => reqUrl?.includes(url))
  ) {
    return MOCK_API
  }

  if (baseUrl) {
    return baseUrl
  }

  return `${window.location.origin}`
}
